import z from '@/lib/zod';
import { toLegacySubTab } from '@/lib/helpers/list-tabs';
import { ERROR_LOGS_TABS } from '@/pages/error-logs/lib/error-logs-filters';
import { commonSearchSchema } from './commonSearchSchema';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from './search-param-schemas';

/** Le due viste del registro errori, validate dal layout per lista e dettaglio. */
export const errorLogsSearchSchema = commonSearchSchema
  .extend({
    viewType: z.enum(['table', 'progressive']).nullish().catch(undefined),
    includeResolved: optionalSearchBoolean(),
    /** Righe aperte della vista progressiva (`LIVELLO`, `LIVELLO:categoria`). */
    expanded: optionalSearchString(),
    from: optionalSearchString(),
    to: optionalSearchString(),
    tenantId: optionalSearchString(),
    categoryName: optionalSearchString(),
    /** Tab della tabella (come la webapp). */
    subTab: optionalSearchString(),
    /**
     * Link di prima con il livello: diventa `subTab` e non esce dallo
     * schema. Da rimuovere dopo il 2026-12-31.
     */
    level: optionalSearchString(),
  })
  .transform(({ level, ...search }) => ({
    ...search,
    subTab: toLegacySubTab({
      tabs: ERROR_LOGS_TABS,
      subTab: search.subTab,
      legacyFilter: level,
    }),
  }));

export type ErrorLogsSearch = z.output<typeof errorLogsSearchSchema>;
